import { default as LoadingSpinner } from 'components/LoadingSpinner';
import { StyledSiteMapCanvas } from 'components/SiteMapCanvas';
import { useSiteMapQuery } from 'lib/hooks/queries';
import { useAppDispatch } from 'lib/hooks/redux';
import useWindowDimensions from 'lib/hooks/useWindowDimensions';
import { initiateBuildingLevelSVG } from 'lib/utils';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
// import Building_1 from 'lib/assets/building_1.svg';

interface Props {
  onLoadFinish: () => void;
  resetTransform: any;
}

const SiteMapBuildingCanvas = ({ onLoadFinish, resetTransform }: Props) => {
  // Redux Hooks and State
  const dispatch = useAppDispatch();

  // Get Site Map Data from React-Query Cache (No Params)
  const siteMapData = useSiteMapQuery().data!;
  // Semantic Vars From Site Map Data
  const {
    community: { type: communityType },
  } = siteMapData;

  // Constants
  const { height: winHeight, width: winWidth } = useWindowDimensions();
  // const currSelectedLevel = 0;
  // const selectedBuildingId = '0';
  const screenRatio = winWidth / winHeight;
  const svg = document.querySelector('#site-map-building-svg svg');

  // React Hooks
  const [isStacked] = useState<boolean>(communityType !== 'SFM');
  const [isSvgLandscape, setIsSvgLandscape] = useState<boolean | undefined>();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (svg) {
      const svgWidth = parseInt(svg.getAttribute('width')!);
      const svgHeight = parseInt(svg.getAttribute('height')!);

      let isSvgLandscape = svgWidth / svgHeight > screenRatio;
      setIsSvgLandscape(isSvgLandscape);
      setLoading(false);
    }
  }, [svg, screenRatio]);

  // useEffect(() => {
  //   if (svg) {
  //     changeLevel(currSelectedLevel!);
  //   }
  // }, [currSelectedLevel, svg]);

  useEffect(() => {
    if (!loading) {
      initiateBuildingLevelSVG({ dispatch });
    }
  }, [dispatch, loading]);

  // Conditions
  // if (!selectedBuildingId) {
  //   return <LoadingSpinner />;
  // }

  return (
    <StyledSiteMapLevelWrapper data-cy="site-map-level-wrapper">
      {loading && (resetTransform(0), (<LoadingSpinner />))}
      <StyledSiteMapCanvas isSvgLandscape={isSvgLandscape} isStacked={isStacked}>
        {/* <InlineSvg
          role="svg"
          id="site-map-building-svg"
          data-cy="site-map-building-svg"
          src={`${BASE_ASSET_URL}/${communityId}/App/${selectedBuildingId}.svg`} // TODO: check with Jeet/Darren
          onLoad={onLoadFinish}
          style={{ display: loading ? 'none' : '' }}
        /> */}
      </StyledSiteMapCanvas>
    </StyledSiteMapLevelWrapper>
  );
};

export default SiteMapBuildingCanvas;

const StyledSiteMapLevelWrapper = styled.div`
  width: 100vw;
  height: 90vh;
`;
